import { Navigate, useParams } from 'react-router';
import { BoardLayout } from '../planner/board/BoardLayout';
import { currentWeek, dayPath, mondayOf, neighbourDay, parseIsoWeek } from '../planner/weekMath';

const DAY_MS = 86_400_000;

/** One day on the smartboard: the day plan written out under every lesson. */
export default function DayDigibordPage() {
  const params = useParams();
  const target = parseIsoWeek(params);
  const day = Number(params.dag);
  if (!target || !Number.isInteger(day) || day < 1 || day > 5) {
    const now = currentWeek();
    return <Navigate to={`/week/${now.year}/${now.week}/digibord`} replace />;
  }
  const date = new Date(mondayOf(target).getTime() + (day - 1) * DAY_MS);
  const title = new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(date);
  return (
    <BoardLayout
      key={`${target.year}-${target.week}-${day}`}
      target={target}
      day={day}
      backHref={dayPath(target, day)}
      previousHref={neighbourDay(target, day, -1, '/digibord')}
      nextHref={neighbourDay(target, day, 1, '/digibord')}
    >
      <h1 className="text-[clamp(1.2rem,2vw,2.6rem)] first-letter:uppercase">{title}</h1>
    </BoardLayout>
  );
}
